import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["boxSize", "color"];
import React from 'react';
import { BaseIcon } from "../../../index.js";
export var Cart = function Cart(_ref) {
  var boxSize = _ref.boxSize,
    color = _ref.color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(BaseIcon, _extends({
    viewBox: "0 0 24 24",
    boxSize: boxSize,
    color: color
  }, props), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bw4gy398oa)",
    transform: "translate(-940 -24)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dn4dzuxhkb)",
    transform: "translate(948.045 43.286)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h1.727v1.714H0V0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M948.91 45a.86.86 0 0 0 .863-.857.86.86 0 0 0-.864-.857.86.86 0 0 0-.864.857.86.86 0 0 0 .864.857z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#69rvfuif1c)",
    transform: "translate(957.545 43.286)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h1.727v1.714H0V0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M958.41 45a.86.86 0 0 0 .863-.857.86.86 0 0 0-.864-.857.86.86 0 0 0-.864.857.86.86 0 0 0 .864.857zM942 27h3.455l2.314 11.477c.163.815.89 1.396 1.727 1.38h8.395a1.724 1.724 0 0 0 1.727-1.38L961 31.286h-14.682",
    stroke: "currentColor",
    strokeWidth: "1.5",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};